module.exports = __webpack_public_path__ + "static/step1-1bdfcdb4c3c9fdeab460919796c901fe.svg";